import { render, staticRenderFns } from "./modal-note.vue?vue&type=template&id=71646802&scoped=true"
import script from "./modal-note.vue?vue&type=script&lang=js"
export * from "./modal-note.vue?vue&type=script&lang=js"
import style0 from "./modal-note.vue?vue&type=style&index=0&id=71646802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71646802",
  null
  
)

export default component.exports